<template>
  <div class="flex flex-col text-sm text-gray-900 form-field" :class="{ optional: required === false }">
    <div v-if="label" class="flex flex-row items-end justify-between mb-2">
      <label class="font-normal">{{ label }}</label>
      <label v-if="required === false" class="text-xs font-medium text-gray-500" type="optional">Optional</label>
    </div>

    <slot>
      <VInput
        :model-value="modelValue"
        v-bind="attrs"
        class="input"
        :type="type"
        :placeholder="placeholder"
        :error="!!error"
        :class="{ error }"
        :autocomplete="autocomplete"
        :maxlength="maxlength"
        :rows="rows"
        @input="handleInput"
      >
        <template #button><slot name="button" /></template>
      </VInput>
    </slot>

    <div v-if="error" :data-testid="`${(label || 'form-field').toLowerCase()}-error`" class="error">
      <slot name="error">{{ error }}</slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
  label: {
    type: String,
    default: null,
  },
  required: {
    type: [String, Boolean],
    default: false,
  },
  modelValue: {
    type: String as PropType<string | null>,
    default: null,
  },
  attrs: {
    type: Object as PropType<Record<string, unknown>>,
    default: () => ({}),
  },
  placeholder: {
    type: String,
    default: '',
  },
  error: {
    type: String as PropType<string | null>,
    default: null,
  },
  type: {
    type: String as PropType<'text' | 'password' | 'email' | 'textarea'>,
    default: 'text',
  },
  autocomplete: {
    type: String,
    default: 'false',
  },
  maxlength: {
    type: [String, Number] as PropType<string | number>,
    default: null,
  },
  rows: {
    type: [String, Number] as PropType<string | number | null>,
    default: null,
  },
})

const emit = defineEmits(['input', 'update:modelValue'])

function handleInput(event: any) {
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}
</script>

<style lang="stylus">
.form-field
  &.gold
    @apply text-gold-800
    [type="optional"]
      @apply text-gold-800
    &.optional
      @apply text-gold-500
      [type="optional"]
        @apply text-gold-500
    .input:not(.error)
      @apply border-gold-800
    :deep(.mx-input)
      @apply border-gold-800 hover_border-gold-800
  .error
    @apply text-red-800
</style>
